module.exports = __webpack_public_path__ + "static/media/camera@1x.5c9ec490.svg";